// extracted by mini-css-extract-plugin
export default {"container":"idleOverlay_container__CJN4F","gestureImage":"idleOverlay_gestureImage__aYbSE","fadeIn":"idleOverlay_fadeIn__wjW39"};